import styles from "./MonthlyViewMobile.module.scss";
import DayPreviewMobile from "./components/day-preview-mobile/DayPreviewMobile";
import SingleMonth from "./components/mini-calendar/SingleMonth";

const MonthlyViewMobile = () => (
  <div className={styles.container}>
    <SingleMonth />
    <DayPreviewMobile />
  </div>
);

export default MonthlyViewMobile;
